import React from 'react'

import { getValueFormat } from '@baurine/grafana-value-formats'
import { get } from 'lodash'

import { MetricValue } from '~/pages/reports/shared/types'

import { ComponentData } from '../table_component'
import { getUnit } from './util'

export const MetricStats: React.FC<ComponentData> = ({
  metricStats,
  value
}) => {
  const metricKey = value.split('.')[0]
  // value maybe accessor#valueKey
  // to access metricStats[accessor].value[valueKey]
  const [accessor, valueKey] = value.split('#')
  const metric = get(metricStats, metricKey, null)
  if (value === 'Avg_KV_request_duration:by_type.values.mean.value.Prewrite') {
    console.log(metric)
  }
  if (!metric) {
    return value
  }

  const v = get(metricStats, accessor, accessor) as MetricValue
  const vv = valueKey ? get(v.value, valueKey) : v.value
  const unit = getUnit(metric, v)

  return (
    <span>
      {typeof vv === 'number'
        ? getValueFormat(unit)(vv, 2)
        : JSON.stringify(vv)}
    </span>
  )
}
